export default "__VITE_ASSET__7nMvRmUR__"